<template>
    <div id="app">
        <!--<vue-particles-->
                <!--color="#2d3436"-->
                <!--:particleOpacity="0.7"-->
                <!--:particlesNumber="80"-->
                <!--shapeType="circle"-->
                <!--:particleSize="4"-->
                <!--linesColor="#141414"-->
                <!--:linesWidth="1"-->
                <!--:lineLinked="true"-->
                <!--:lineOpacity="0.4"-->
                <!--:linesDistance="150"-->
                <!--:moveSpeed="2"-->
                <!--:hoverEffect="true"-->
                <!--hoverMode="grab"-->
                <!--:clickEffect="true"-->
                <!--clickMode="push"-->
                <!--class="lizi"-->
        <!--&gt;-->
        <!--</vue-particles>-->
    </div>
</template>

<script>
    export default {
        name: "Background"
    }
</script>

<style scoped>
    #app {
        /*width: 100%;*/
        /*height: calc(100% - 100px);*/
        /*position: absolute;*/
        /*width: 100vw;*/
        /*height: 100vh;*/
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #ff7f50;
        background: #e4faf0;  margin-top: 0;
    }

</style>